import { Panel } from "../../shared/components/Panel";
import { SubjectReviewList } from "../review/SubjectReviewList";

/** The editor's side: which of their lectures are still waiting on a review.
 *  Boxed in a panel, in the profile's left column. */
export default function SubjectsBlock() {
  return (
    <Panel title="Предметы">
      <SubjectReviewList
        role="editor"
        emptyMessage="За вами не закреплены предметы."
      />
    </Panel>
  );
}
